export const QUESTION_TYPES = {
    SINGLE_LINE: "single_line",
    MULTIPLE_LINE:  "multiple_line",
    YES_NO:   'yes_no',
    SINGLE_CHOICE: 'single_choice',
    MULTIPLE_CHOICE:   'multiple_choice',
 }